import * as translator from '../../../utils/translator';

/** Mirrors funnel-common FOUNDAYO_ROUTE; client has no funnel-common dep. */
export const FOUNDAYO_PDP_FALLBACK = '/uk/treatments/foundayo-pill';

export function getRedesignAssetRoot(): string {
  const cdnRoot = (
    (window as any).clientConfig?.assetBasePath ||
    (window as any).clientProps?.assetBasePath ||
    'https://images.doktorabc.com'
  ).replace(/\/$/, '');
  return /redesign_2025$/.test(cdnRoot) ? cdnRoot : `${cdnRoot}/redesign_2025`;
}

export function getFoundayoPdpUrl(opts?: {
  categoryUrl?: string;
  weightLossUrl?: string;
}): string {
  const fromProps = (window as any).clientProps?.foundayoProductUrl as string | undefined;
  if (fromProps) return fromProps;
  if (opts?.categoryUrl) return opts.categoryUrl;
  if (opts?.weightLossUrl) return opts.weightLossUrl;
  return FOUNDAYO_PDP_FALLBACK;
}

export type FoundayoPromoCopy = {
  mainBadge: string;
  mainTitle: string;
  mainSubtitle: string;
  wlBadge: string;
};

/** Same keys as SSR SideMenu EJS; EN fallbacks match hardcoded React copy today. */
export function foundayoPromoCopy(language: string): FoundayoPromoCopy {
  const t = (path: string, fallback: string) =>
    translator.translate(language, 'layout', path) || fallback;

  return {
    mainBadge: t('sidebar/foundayo_menu_promo/main_badge', '✦ New Treatment'),
    mainTitle: t('sidebar/foundayo_menu_promo/main_title', 'Weight Loss'),
    mainSubtitle: t(
      'sidebar/foundayo_menu_promo/main_subtitle',
      'New tablet treatment available'
    ),
    wlBadge: t('sidebar/foundayo_menu_promo/wl_badge', 'New tablet available'),
  };
}
